import type { TaxRate } from '../types/taxRateMaintenance';

export const mockTaxRates: TaxRate[] = [
  {
    id: '1',
    taxRateValue: '0.00%',
    description: '0% Tax Rate',
    isDefault: false,
    isActive: true,
    createdAt: new Date('2024-01-15'),
    lastModified: new Date('2025-01-16')
  },
  {
    id: '2',
    taxRateValue: '5.00%',
    description: '5% Tax Rate',
    isDefault: false,
    isActive: true,
    createdAt: new Date('2024-02-10'),
    lastModified: new Date('2025-01-15')
  },
  {
    id: '3',
    taxRateValue: '10.00%',
    description: '10% Tax Rate',
    isDefault: true,
    isActive: true,
    createdAt: new Date('2024-03-05'),
    lastModified: new Date('2025-01-14')
  },
  {
    id: '4',
    taxRateValue: '15.00%',
    description: '15% Tax Rate',
    isDefault: false,
    isActive: true,
    createdAt: new Date('2024-04-20'),
    lastModified: new Date('2025-01-16')
  },
  {
    id: '5',
    taxRateValue: '20.00%',
    description: '20% Tax Rate',
    isDefault: false,
    isActive: true,
    createdAt: new Date('2024-05-12'),
    lastModified: new Date('2024-12-20')
  }
];